module.exports = __webpack_public_path__ + "media/retinus-pvp-demo-video10.e523a38f.mp4";